const MODULE_NAME = 'WorkInstructionModule';

export const GET_WORK_INSTRUCTION_PACKAGES = `${MODULE_NAME}/GET_WORK_INSTRUCTION_PACKAGES`;
export const CURRENT_WORK_INSTRUCTION_PACKAGE = `${MODULE_NAME}/CURRENT_WORK_INSTRUCTION_PACKAGE`;
export const GET_WORK_INSTRUCTION = `${MODULE_NAME}/GET_WORK_INSTRUCTION`;
